/*
 * ============================================================
 * SEIC Bikes AU — Page Composer JavaScript
 * ============================================================
 * Accordion: native <details>/<summary> handles toggle automatically
 *   — we only enhance smooth height animation via CSS.
 *
 * Marquee: (Phase 3) infinite scroll loop via requestAnimationFrame.
 *
 * Created: 2026-04-24
 * ============================================================
 */

(function () {
  'use strict';

  /* --------------------------------------------------------
   * Accordion — smooth open/close animation
   *
   * Uses native <details>/<summary> for accessibility + SEO;
   * JS adds a height transition that the browser doesn't provide.
   * -------------------------------------------------------- */
  function initAccordion() {
    const items = document.querySelectorAll('.brand-accordion__item');
    if (!items.length) return;

    items.forEach(function (details) {
      const content = details.querySelector('.brand-accordion__content');
      if (!content) return;

      // Wrap content height for smooth animation
      details.addEventListener('toggle', function () {
        if (details.open) {
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          content.style.maxHeight = '0px';
        }
      });

      // Initial state
      if (!details.open) {
        content.style.maxHeight = '0px';
      }
    });
  }

  /* --------------------------------------------------------
   * Init on DOM ready + handle Shopify section reload
   * -------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordion);
  } else {
    initAccordion();
  }

  // Shopify Customizer: re-init when a section is re-rendered
  document.addEventListener('shopify:section:load', initAccordion);
})();
